/**
 * View all (active + deleted) is limited to Admin, System Admin, and Service Admin.
 */
export function canViewAllRecords(user) {
  const payload = user?.data;
  if (!payload) return false;
  const names = [];
  if (Array.isArray(payload.roles) && payload.roles.length > 0) {
    names.push(...payload.roles);
  } else if (payload.role) {
    names.push(payload.role);
  }
  return names.some((roleName) => {
    const normalized = String(roleName ?? '')
      .trim()
      .toUpperCase()
      .replace(/[\s_-]+/g, '');
    return (
      normalized === 'ADMIN'
      || normalized === 'SYSTEMADMIN'
      || normalized === 'SERVICEADMIN'
    );
  });
}
